module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-01-m.0475d85dec34a54dc266150e639e22d0.png";